export enum BrowserType {
  Safari = 'Safari',
  Chrome = 'Chrome',
}

export enum HeadingStyleType {
  Plain = 'Plain',
  Highlighted = 'Highlighted',
}

export const TYPEFORM_IDS = {
  WORK_INDUSTRY_ID: 'airgAP1av0Rq',
  USER_INDUSTRY_ID: '0YKwKP2m6cKC',
};

export const Pagination = {
  CATEGORIES_PER_PAGE: 6,
  PLATFORMS_PER_PAGE: 6,
  BLOGS_PER_PAGE: 9,
  SEARCHED_BLOGS_PER_PAGE: 8,
  AUTHORS_BLOG_PER_PAGE: 8,
};

export const ROUTES = {
  HOMEPAGE: '/',
  BLOGHOMEPAGE: '/blog/',
  CATEGORIES: '/blog/category',
  PLATFORMS: '/blog/platforms',
  TRENDING: '/blog/trending',
};

export const DEFAULT_LOGO_URL = `${process.env.NEXT_PUBLIC_SHARED_CDN_URL}/logos/purple_logo_with_text.svg`;
